import { Controller } from 'react-hook-form'
import { Input, Select, Textarea } from '@/components/ui'

import { useBienContext } from '../BienContext'
import { useFormContext } from '../SectionForm'
import { typeBienOptions } from '../mandat/options'
import SuggestionImmeuble from './SuggestionImmeuble'

const PropertyDetailsForm = () => {
  const { bien } = useBienContext()
  const { control, watch, errors, hasError, getErrorMessage } = useFormContext()

  const typeBien = watch("type_bien")

  return (
    <div className="card bg-base-100 border border-base-200 rounded-none mb-4">
      <h3 className="text-xl p-4 mb-4">Informations générales du bien</h3>
      <div className="card-body p-4">
        <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
          <div className="flex flex-col items-center gap-4 transition-all duration-300 ease-in-out">
            <Select.Form control={control} 
                name="type_bien" 
                label="Type de bien"
                options={typeBienOptions}
            /> 
            <Controller
              name="nombre_etages"
              control={control}
              render={({ field }) => (
                <label className="input">
                  <span className="label">Nombre d'étages</span>
                  <input
                    type="number"
                    {...field}
                    value={field.value || ''}
                    min="0"
                  />
                </label>
              )}
            />

            <Controller
              name="cadastre"
              control={control}
              render={({ field }) => (
                <label className="input">
                  <span className="label">Référence cadastrale</span>
                  <input
                    type="text"
                    {...field}
                    value={field.value || ''}
                  />
                </label>
              )}
            />

            <Controller
              name="date_construction"
              control={control}
              render={({ field }) => (
                <label className="input">
                  <span className="label">Date de construction</span>
                  <input
                    {...field}
                    value={field.value || ''}
                  />
                </label>
              )}
            />
          </div>

          <div className="flex flex-col items-center gap-4">
            {/* Réf. bâtiment */}
            <Controller
              name="ref_batiment"
              control={control}
              render={({ field }) => (
                <label className="input">
                  <span className="label">Bâtiment</span>
                  <input
                    type="text"
                    {...field}
                    value={field.value || ''}
                  />
                </label>
              )}
            />
            
            {/* Réf. escalier */}
            <Controller
              name="ref_escalier"
              control={control}
              render={({ field }) => (
                <label className="input">
                  <span className="label">Escalier</span>
                  <input
                    type="text"
                    {...field}
                    value={field.value || ''}
                  />
                </label>
              )}
            />

            {/* Réf. étage */}
            <Controller
              name="ref_etage"
              control={control}
              render={({ field }) => (
                <label className="input">
                  <span className="label">Étage</span>
                  <input
                    type="text"
                    {...field}
                    value={field.value || ''}
                  />
                </label>
              )}
            />

            <Textarea.Form control={control}
              name="details_cles"
              label="Détails des clés"
            />
          </div>
          <div className="flex flex-col items-center gap-4">
            <Input.Text control={control}
              name="codage_interne"
              label="Codage"
              rules={{ required: "Le codage est requis" }}
              validator={{hasError, getErrorMessage}}
              className="w-full"
            />
            { typeBien !== 'immeuble' && (<>
                {/* N° appartement */}
                <Controller
                  name="numero_appartement"
                  control={control}
                  render={({ field }) => (
                    <label className="input">
                      <span className="label">N° appartement</span>
                      <input
                        type="text"
                        {...field}
                        value={field.value || ''}
                      />
                    </label>
                  )}
                />

                {/* N° sonnette */}
                <Controller
                  name="numero_sonnette"
                  control={control}
                  render={({ field }) => (
                    <label className="input">
                      <span className="label">N° sonnette</span>
                      <input
                        type="text"
                        {...field}
                        value={field.value || ''}
                      />
                    </label>
                  )}
                />

                {/* N° Parking */}
                <Input.Text control={control}
                  name="numero_parking"
                  label="N° parking ou box"
                />
                
            </>)}
            { (typeBien === 'appartement' || typeBien === 'autre') &&
              <Controller 
                name="immeuble"
                control={control}
                defaultValue=""
                render={({ field  }) => {
                  return (
                    <SuggestionImmeuble
                        objectField={field}
                        originalData={bien.immeuble}
                    />
                  );
                }}
              />
              }
          </div>
        </div>
      </div>
    </div>
  )
}

export default PropertyDetailsForm